// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { precisionM } from 'config/constants'
import { roundToFixed } from 'helpers/reduxFormFunctions'
import { convertBetweenMandFt } from 'helpers/unitConversion'

// v is a value in meters.
// based on the defined unitType, convert as necessary
// for display in the UI.
const valueFromMeters = (v, unitType) => (
  unitType === 'SI'
    ? roundToFixed(v, precisionM)
    : convertBetweenMandFt(v, 'US')
)

export default valueFromMeters
